var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"slides",attrs:{"id":"page-slider"}},_vm._l((5),function(index){return _c(("PageSlide" + index),{key:index,tag:"component",attrs:{"show":index == _vm.activeSlide}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }